// src/WorkHistory.js
import React, { useState } from "react";
import { Card, Typography, Row, Col, Button, Modal } from "antd";
import { WORK_HISTORY_DATA, WORK_HISTORY_INTRO } from "../constants";

const { Title, Paragraph } = Typography;

const WorkHistory = (props) => {
  const { isMobile } = props;

  return (
    <div>
      <Title level={3}>Work History</Title>
      <div level={5} style={{ fontSize: "16px", paddingBottom: "15px" }}>
        {WORK_HISTORY_INTRO}
      </div>

      <Row gutter={[16, 16]}>
        {WORK_HISTORY_DATA.map((entry, index) => (
          <WorkHistoryCard
            key={index}
            isMobile={isMobile}
            period={entry.period}
            title={entry.title}
            subtitle={entry.subtitle}
            description={entry.description}
          />
        ))}
      </Row>
    </div>
  );
};
const WorkHistoryCard = ({
  isMobile,
  period,
  title,
  subtitle,
  description,
}) => {
  const [showFullDescription, setShowFullDescription] = useState(false);

  const toggleDescription = () => {
    if (isMobile) {
      setShowFullDescription(!showFullDescription);
    } else {
      showDetailsModal();
    }
  };
  const showDetailsModal = () => {
    Modal.info({
      title: `${period}`,
      content: (
        <div>
          <Title level={4}>{title}</Title>
          <Paragraph>{description}</Paragraph>
        </div>
      ),
      centered: true,
    });
  };
  return (
    <Col
      xs={24}
      sm={12}
      md={8}
      lg={6}
      xl={6}
      xxl={4}
      style={{ marginBottom: "16px" }}
    >
      <Card
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ color: "grey" }}>{period}</div>
        <Title level={4}>{title}</Title>
        <Paragraph
          ellipsis={{ rows: !showFullDescription ? 3 : 10 }}
          style={{ marginBottom: "16px" }}
        >
          {showFullDescription
            ? description
            : `${description.slice(0, 150)}...`}
        </Paragraph>
        {description.length > 150 && (
          <Button type="link" onClick={toggleDescription}>
            {showFullDescription ? "Read Less" : "Read More"}
          </Button>
        )}{" "}
      </Card>
    </Col>
  );
};

export default WorkHistory;
